(() => {
  if (customElements.get('read-more')) {
    return;
  }

  class ReadMore extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        trigger: '[data-trigger]',
        dots: '[data-dots]',
        more: '[data-more]',
      }
      this.isExpanded = false;
    }

    connectedCallback() {
      this.trigger = this.querySelector(this.selectors.trigger);
      this.more = this.querySelector(this.selectors.more);
      if (!this.trigger || !this.more) {
        return
      }

      this.toggleEvents();
    }

    /**
     * Disconnected callback.
     */
    disconnectedCallback() {
      this.toggleEvents(true);
    }

    /**
     * Toggle events.
     * 
     * @param {Boolean} remove 
     */
    toggleEvents(remove) {
      this.trigger[remove !== true ? 'addEventListener' : 'removeEventListener']('click', this.toggle.bind(this));
    }

    /**
     * Toggle.
     */
    toggle() {
      this.trigger.innerText = 
        this.isExpanded ? 'Read more' : 'Read less';
      this.more.classList.toggle('hidden', this.isExpanded);
      this.querySelector(this.selectors.dots)?.classList?.toggle('hidden', !this.isExpanded);

      this.isExpanded = !this.isExpanded;
    }
  }

  customElements.define('read-more', ReadMore);
})();